import Vue from 'vue'
import router from '../../router/index'

import hasPermi from './hasPermi.js'
import axios from 'axios';
Vue.directive('hasPermi', hasPermi);

const whiteList = ['homepage', 'screen_graph', "screen_graph_demo","auto_login", "free_login_phone"
  , "screen_now","screen_location","screen_screens","screen_prevent","screen_tickets","screen_hazard",
  "page_not_found", "message", "personal", "process_def_detail","work_ticket_print"];
router.beforeEach((to, from, next) => {
  if (to.path.indexOf("login") > -1) {
    next();
    return;
  }
  if (whiteList.indexOf(to.name) !== -1) {
    next();
    return;
  }
  let allPermission = sessionStorage.getItem('allPermission');
  if(allPermission){
    next();
    return;
  }
  let token = sessionStorage.getItem('token');
  let tenantId = sessionStorage.getItem('tenantId');
  let user = JSON.parse(sessionStorage.getItem('user'));
  var authToken = getQueryParam('authToken')
  console.log(authToken)
  function getQueryParam(param) {
    const url = window.location.href;
    const regex = new RegExp(`[?&]${param}=([^&#]*)`, 'i');
    const match = regex.exec(url);
    return match ? decodeURIComponent(match[1]) : null;
}


  if(authToken!=="" && authToken!==null){
      axios.get(getUssoUrl()+'/loginSystem/'+authToken).then((res)=>{
      if(res.data.code !=='401'){
        console.log(authToken)
        var user = res.data.user
        sessionStorage.setItem("tenantId", res.data.tenantId);
        sessionStorage.setItem("user", JSON.stringify(res.data.user));
        sessionStorage.setItem("token", JSON.stringify(res.data.token));
        let permissions = user.menus;
        const hasPermissions = permissions.some(permission => {
          return [to.name].includes(permission.menu_code)
        });
        console.log('1')
      if (hasPermissions) {
        console.log('2')
          next();
        }
      }else{
        next(`/404`);
      }
    })
  }

  // if (!token || !tenantId || !user) {
  //   console.log('一号拦截')
  //   next(`/404`);
  //   return;
  // }
  
  let permissions = user.menus;
  const hasPermissions = permissions.some(permission => {
    return [to.name].includes(permission.menu_code)
  });
  if (hasPermissions) {
    next();
  } else {
    console.log('二号拦截')
    next(`/404`);
  }
});






// WEBPACK FOOTER //
// ./src/common/permission/permission.js